import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div\n  class={{this.cssClasses}} ...attributes {{did-update this.onValueChange @value}}\n  {{did-update this.onDisabledChange @disabled}}\n  {{did-update this.onConfigChange @min @max @step @orientation @reversed}}\n>\n  {{! noUiSlider monta il suo widget dentro questo div al did-insert }}\n  <div class=\'nouislider-target\' {{did-insert this.onInsert}}></div>\n</div>");

var _class, _descriptor;
let BbSliderComponent = (_class = class BbSliderComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "_isSliding", _descriptor, this);
    this._slider = null;
    this._element = null;
  }
  // ─── CSS classes (sostituisce classNames + classNameBindings) ─────────────

  get cssClasses() {
    const classes = ['ui-slider'];
    if (this._isSliding) classes.push('sliding');
    if (this.args.mood) classes.push(`mood-${this.args.mood}`);
    classes.push(this.args.range ? 'range' : 'singular');
    classes.push(this.args.fill !== false ? 'fill' : 'fit');
    return classes.join(' ');
  }

  // ─── Lifecycle ────────────────────────────────────────────────────────────

  onInsert(element) {
    this._element = element;
    const start = this._resolveStart();
    const stepDecimals = (String(this.args.step ?? 1).split('.')[1] ?? '').length;
    const tooltipFormatter = this.args.formatter ?? {
      to: v => v.toFixed(stepDecimals),
      from: Number
    };
    noUiSlider.create(element, {
      start,
      range: {
        min: Number(this.args.min ?? 0),
        max: Number(this.args.max ?? 100)
      },
      step: Number(this.args.step ?? 1),
      connect: this.args.range ? true : 'lower',
      orientation: this.args.orientation ?? 'horizontal',
      direction: this.args.reversed ? 'rtl' : 'ltr',
      tooltips: this.args.tooltip !== 'hide' ? tooltipFormatter : false,
      ...(this.args.formatter ? {
        format: this.args.formatter
      } : {})
    });
    this._slider = element.noUiSlider;
    this._addEventListeners();
    if (this.args.disabled) {
      element.setAttribute('disabled', true);
    }
  }
  willDestroy() {
    super.willDestroy();
    try {
      this._slider?.off();
      this._slider?.destroy();
    } catch {
      // slider già distrutto
    }
    this._slider = null;
    this._element = null;
  }

  // ─── did-update handlers (sostituiscono i 3 observer Classic) ────────────

  onValueChange() {
    // Non aggiornare la posizione mentre l'utente sta trascinando: causerebbe
    // salti visivi o interruzione del gesto (soprattutto con immediateResponse).
    if (!this._slider || this._isSliding) return;
    const value = this._resolveStart();
    this._slider.set(value);
  }
  onDisabledChange() {
    if (!this._element) return;
    if (this.args.disabled) {
      this._element.setAttribute('disabled', true);
    } else {
      this._element.removeAttribute('disabled');
    }
  }
  onConfigChange() {
    if (!this._slider || !this._element) return;
    this._slider.updateOptions({
      range: {
        min: Number(this.args.min ?? 0),
        max: Number(this.args.max ?? 100)
      },
      step: Number(this.args.step ?? 1),
      orientation: this.args.orientation ?? 'horizontal',
      direction: this.args.reversed ? 'rtl' : 'ltr'
    }, true); // true = forza il re-render

    this._slider.set(this._resolveStart());
  }

  // ─── Helpers privati ─────────────────────────────────────────────────────

  _resolveStart() {
    const {
      value,
      min = 0,
      max = 100,
      range,
      defaultValue
    } = this.args;
    if (value != null) {
      return range && !Array.isArray(value) ? [value, value] : value;
    }
    if (defaultValue != null) return defaultValue;
    return range ? [min, max] : min;
  }
  _addEventListeners() {
    this._slider.on('start', (values, handle) => {
      this._isSliding = true;
      const value = this._parseValue(values, handle);
      this.args.action?.('slideStart', {
        context: this,
        value
      });
    });
    this._slider.on('end', (values, handle) => {
      this._isSliding = false;
      const value = this._parseValue(values, handle);
      // Propaga il nuovo valore al parent (DDAU — sostituisce il two-way binding Classic)
      this.args.changed?.(value);
      this.args.action?.('slideStop', {
        context: this,
        value
      });
    });

    // 'change' fires on tap-to-jump (eventTap) where 'start'/'end' never fire.
    // Guard: skip when _isSliding=true because 'end' already handles drag-end.
    this._slider.on('change', (values, handle) => {
      if (this._isSliding) return;
      const value = this._parseValue(values, handle);
      this.args.changed?.(value);
      this.args.action?.('slideStop', {
        context: this,
        value
      });
    });
    if (this.args.immediateResponse) {
      // 'slide' si attiva SOLO su input utente, mai su _slider.set() programmativo.
      // 'update' invece si attiva anche su set() creando un loop: drag → changed →
      // @value cambia → onValueChange → set() → update → changed → loop infinito.
      this._slider.on('slide', (values, handle) => {
        const value = this._parseValue(values, handle);
        this.args.changed?.(value);
        this.args.action?.('slide', {
          context: this,
          value
        });
      });
    }
  }
  _parseValue(values, handle) {
    if (this.args.range) {
      return values.map(Number);
    }
    return Number(values[handle ?? 0]);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_isSliding", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onValueChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDisabledChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDisabledChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfigChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onConfigChange"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbSliderComponent);

export { BbSliderComponent as default };
//# sourceMappingURL=bb-slider.js.map
